import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy WordPress page — permanently redirect to the homepage.
export const Route = createFileRoute("/will-i-go-bald-calculator")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
